import { Link, useLoaderData } from "react-router-dom"
import schools from "./schools"
import {BiBusSchool} from 'react-icons/bi'
import {SlLocationPin} from 'react-icons/sl'

export default function Careers() {
  // const careers = useLoaderData()
  let sc1 = schools[0]
  console.log("data is : ", typeof(sc1._id))

  return (
    <div className="container careers schools">
    {schools.map(school => (
      <Link className="link-school" to={school._id.toString()} key={school._id}>
        <h3 className="school-name"> مدرسة  - {school.shem_beit_sefer}
    <BiBusSchool  size={25} className="text-left icon"/></h3>
        <p className="school-location">
          <SlLocationPin size={20} className='icon'/>
            {school.ezor}</p>
      </Link>
    ))}
  </div>
  )
}

// data loader
// export const careersLoader = async () => {
//   const res = await fetch('http://localhost:4000/careers')

//   if (!res.ok) {
//     throw Error('Could not fetch the list of careers')
//   }

//   return res.json()
// }